import styled from 'styled-components';

interface CustomBadgeProps {
	color: keyof typeof riskColorsMap;
}

const riskColorsMap = {
	VERY_LOW: '#17A93B',
	LOW: '#FFB40A',
	MODERATE: '#F2751C',
	HIGH: '#D13342',
	VERY_HIGH: '#7828C8',
	NOT_AVALIATED: '#D9D9D9'
};

function getRiskColorText(color: string): string {
	return color === 'NOT_AVALIATED' ? '#262626' : '#fff';
}

export const CustomBadge = styled.div<CustomBadgeProps>`
	background-color: ${({ color }) => riskColorsMap[color] || '#7828C8'};
	border-radius: 4px;
	color: ${({ color }) => getRiskColorText(color)};
	font-size: 16px;
	font-weight: 600;
	height: 36px;
	line-height: 36px;
	padding: 0 10px;
`;

export const CustomBadgeLibertyMutual = styled.div`
	color: rgb(47, 84, 235);
	font-weight: 600;
	font-size: 0.75rem;
	border-radius: 0.25rem;
	padding: 0.4rem 1rem;
	border: 1px solid rgb(47, 84, 235);
	background-color: rgba(47, 84, 235, 0.05);
`;

export const ContainerBadgeLibertyMutual = styled.div`
	display: flex;
	gap: 0.5rem;
`;

export const CustomLabel = styled.span`
	font-size: 0.9rem;
	font-weight: 600;
	color: #262626;
`;
